<template>
  <div id="atendimentos-no-mes">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Relatório atendimentos"
            description="Atendimentos, procedimentos, vacinas ou visitas realizados nos últimos 90 dias"
            url="/dashboard"
          />
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-group">
            <label for="">Data inicial</label>
            <input type="date" class="form-control" v-model="periodoInicial" />
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-group">
            <label for="">Data final</label>
            <input type="date" class="form-control" v-model="periodoFinal" />
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-group">
            <button
              class="btn btn-filter"
              type="button"
              :disabled="loadingBtn"
              @click="buscarDados"
            >
              Buscar
              <b-spinner
                label="Spinning"
                small
                variant="white"
                v-if="loadingBtn"
              ></b-spinner>
            </button>
          </div>
        </div>
      </div>
      <modal-atendimentos
        :enabled="enabledModalAtendimentos"
        :atendimentos="atendimentos"
        :profissional="profissional"
        @update:enabled="enabledModalAtendimentos = $event"
      ></modal-atendimentos>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from './SectionTitle'
import utils from '@/mixins/utils.js'
import ModalInfo from './ModalInfo'
import ModalAtendimentos from './ModalAtendimentos'

export default {
  name: 'AtendimentosNoMesProfissional',
  metaInfo: {
    title: 'Relatório atendimentos',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    ModalInfo,
    ModalAtendimentos,
  },
  mixins: [utils],
  computed: {},
  data() {
    return {
      periodoInicial: '',
      periodoFinal: '',
      loading: false,
      loadingBtn: false,
      enabledModalAtendimentos: false,
      profissional: null,
      atendimentos: [],
    }
  },
  methods: {
    /**
     * Buscar os dados
     * */
    async buscarDados() {
      try {
        if (this.periodoInicial === '' && this.periodoFinal === '') {
          this.$toast.error(
            'Selecione uma data de início e de fim!',
            'Error:',
            {
              position: 'topRight',
            }
          )
          return false
        }

        if (new Date(this.periodoInicial) > new Date(this.periodoFinal)) {
          this.$toast.error(
            'O período inicial não pode ser maior do que o período final!',
            'Error:',
            {
              position: 'topRight',
            }
          )
          return false
        }

        this.loading = true
        this.loadingBtn = true

        const inicio = this.periodoInicial.replaceAll('-', '')
        const fim = this.periodoFinal.replaceAll('-', '')

        let mapIdFicha = {
          3: 8,
          6: 7,
          8: 5,
          13: 14,
          4: 4,
        }

        let idFicha = mapIdFicha[this.$store.state.id_funcao]
        let cod = this.$store.state.cos_dim_prof

        const response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/profissional/${cod}/${idFicha}/${inicio}/${fim}`
        )
        if (response) {
          this.profissional = {
            no_profissional: this.$store.state.username,
            co_dim_profissional: this.$store.state.cos_dim_prof,
            id_ficha: idFicha,
          }
          this.enabledModalAtendimentos = true
          this.atendimentos = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingBtn = false
      }
    },

    /**
     * Carrega as datas do período final e inicial
     */
    carregarDatas() {
      const hoje = new Date()
      const menos90 = new Date()
      menos90.setDate(menos90.getDate() - 90)

      const formatar = (d) => {
        const ano = d.getFullYear()
        const mes = String(d.getMonth() + 1).padStart(2, '0')
        const dia = String(d.getDate()).padStart(2, '0')
        return `${ano}-${mes}-${dia}`
      }

      this.periodoFinal = formatar(hoje)
      this.periodoInicial = formatar(menos90)
    },
  },
  created() {
    this.carregarDatas()
  },
}
</script>

<style lang="scss" scoped>
#atendimentos-no-mes {
  .btn-filter {
    margin-top: 30px;
  }
  .filter-select {
    margin: 0;
  }
}
</style>

<style scoped>
#atendimentos-no-mes .v-select {
  min-width: 300px;
}
@media screen and (max-width: 656px) {
  #atendimentos-no-mes .v-select {
    width: 100%;
  }
}
</style>
